module.exports = __webpack_public_path__ + "static/media/ts8cr93.fb893150.png";